module.exports = __webpack_public_path__ + "img/collection-memoireRingsBudgetLow@2x.7d9c546.webp";